export const reportQueryStatuses = ['REQUESTED', 'LOADING', 'SUCCESS', 'FAILED'] as const;
